import R from 'ramda'

const SEND_FACEBOOK_BLAST_DISPLAY_TYPE = 'Send Facebook Blast'
const SEND_FACEBOOK_BLAST_TRIGGER_TYPE = 'SEND_FACEBOOK_BLAST'

const isSendFacebookBlastFormAction = R.propEq(
  'type',
  SEND_FACEBOOK_BLAST_DISPLAY_TYPE
)

const isPlainTextResponse = R.pipe(
  R.prop('blastImageUrl'),
  R.either(R.isNil, R.isEmpty)
)

const constructPlainTextResponse = R.applySpec({
  type: R.always(SEND_FACEBOOK_BLAST_TRIGGER_TYPE),
  message: {
    message: {
      text: R.prop('blastText')
    }
  }
})

const constructImageTemplateResponse = R.applySpec({
  type: R.always(SEND_FACEBOOK_BLAST_TRIGGER_TYPE),
  message: {
    message: {
      attachment: {
        type: R.always('template'),
        payload: {
          elements: [
            {
              title: R.prop('blastTemplateTitle'),
              subtitle: R.prop('blastText'),
              image_url: R.prop('blastImageUrl'),
              default_action: {
                url: R.prop('blastTemplateActionUrl'),
                type: R.always('web_url'),
                webview_height_ratio: R.always('tall')
              }
            }
          ],
          template_type: R.always('generic')
        }
      }
    }
  }
})

const constructGenericTemplateAction = R.cond([
  [isPlainTextResponse, constructPlainTextResponse],
  [R.T, constructImageTemplateResponse]
])

const constructCustomTemplateAction = R.applySpec({
  type: R.always(SEND_FACEBOOK_BLAST_TRIGGER_TYPE),
  isCustomTemplate: R.always(true),
  message: R.pipe(R.prop('customDmTemplate'), JSON.parse)
})

const appendFrequency = blastAction => {
  const store = require('../../../../../../store')
  const {
    notificationFrequency: frequency
  } = store.default.getState().form.widget.values

  return !frequency ? blastAction : { ...blastAction, frequency }
}

const convertSendBlastFormActionToWidgetAction = R.cond([
  [
    R.propEq('action', 'TEMPLATE_GENERIC'),
    R.pipe(constructGenericTemplateAction, appendFrequency)
  ],
  [
    R.propEq('action', 'TEMPLATE_CUSTOM'),
    R.pipe(constructCustomTemplateAction, appendFrequency)
  ]
])

export {
  isSendFacebookBlastFormAction,
  convertSendBlastFormActionToWidgetAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/form-to-widget/send_facebook_blast.js